export default __webpack_public_path__ + "static/media/orange.3abb13bc.png";